
import api from '../../utils/api';

const defaultState = {
    lecture: null,
    lectureVideo: null
};

export default (state = defaultState, action) => {
    switch(action.type){

        case 'GOT_LECTURE':
            return {
                ...state,
                lecture: action.payload,
                lectureVideo: action.payload.VideoFile[0] ? {
                    ...action.payload.VideoFile[0],
                    src: api.makeFileURL(action.payload.VideoFile[0].url, action.payload.token)
                } : null
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/userVideoReducer.js